// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withState } from 'recompose';
import Radium from 'radium';
import {
  Card,
  CardHeader,
  CardBlock,
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import firebase from 'firebase/app';

import NewEmployee from './NewEmployee';

type Props = {|
  // recompose
  selectedUid: string,
  onSelectedUidChange: (uid: string) => void,
  showConfirmation: boolean,
  onShowConfirmationChange: (show: boolean) => void,

  // redux
  me: Object,
  loading: boolean,
|};

type State = {|
  employees: Array<Object>,
|};

class Employees extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    if (!!props.me) {
      this._createSnapshotListener(props.me);
    }
  }

  state = {
    employees: [],
  };

  componentWillReceiveProps(next) {
    if (next.me && next.me.uid) {
      const { me } = next;
      this._createSnapshotListener(me);
    }
  }

  _createSnapshotListener = me => {
    firebase
      .firestore()
      .collection(`users`)
      .where('communityId', '==', me.communityId)
      .where('roles', 'array-contains', 'employee')
      .onSnapshot(snap => {
        const employees = snap.docs
          .map(doc => ({ ...doc.data(), uid: doc.id }))
          .filter(_user => _user.uid !== me.uid);

        this.setState(prevState => ({ ...prevState, employees }));
      });
  };

  _deleteEmployee = async uid => {
    const deleteEmployee = firebase.functions().httpsCallable('deleteEmployee');
    await deleteEmployee({ uid });
  };

  _hideModal = () => {
    this.props.onShowConfirmationChange(false);
  };

  render() {
    const {
      loading,
      showConfirmation,
      onShowConfirmationChange,
      selectedUid,
      onSelectedUidChange,
    } = this.props;
    const { employees } = this.state;

    return (
      <div className="animated fadeIn">
        <Container fluid>
          <Row>
            <Col>
              <Card>
                <CardHeader style={styles.title}>Mitarbeiter</CardHeader>
                <CardBlock>
                  {loading ? (
                    <div>Mitarbeiter werden geladen ...</div>
                  ) : (
                    <Table>
                      <tbody>
                        {employees.map(employee => (
                          <tr key={employee.uid}>
                            <td>{employee.displayName}</td>
                            <td>{employee.email}</td>
                            <td>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  onSelectedUidChange(employee.uid);
                                  onShowConfirmationChange(true);
                                }}
                              >
                                Löschen
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </CardBlock>
              </Card>
            </Col>
            <Col xs="12" sm="12" md="12" lg="5" xl="5">
              <NewEmployee />
            </Col>
          </Row>
        </Container>
        <Modal
          size="zs"
          isOpen={showConfirmation}
          toggle={() => onShowConfirmationChange(!showConfirmation)}
        >
          <ModalHeader>Löschen?</ModalHeader>
          <ModalBody>
            Sind Sie sicher, dass Sie diesen Mitarbeiter unwiderruflich löschen
            wollen?
          </ModalBody>
          <ModalFooter>
            <Button onClick={this._hideModal}>Abbrechen</Button>{' '}
            <Button
              color="danger"
              onClick={async () => {
                await this._deleteEmployee(selectedUid);
                this._hideModal();
              }}
            >
              Löschen
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
const styles = {
  title: {
    fontWeight: 'bold',
  },
};

const mapStateToProps = ({ employees: { loading }, auth }) => {
  const me = auth.firebaseUser;

  return {
    loading,
    me,
  };
};
const mapDispatchToProps = () => ({});

const EmployeesContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedUid', 'onSelectedUidChange', null),
  withState('showConfirmation', 'onShowConfirmationChange', false),
  Radium
)(Employees);

export default EmployeesContainer;



// WEBPACK FOOTER //
// ./src/views/Employees/Employees.js